<mat-dialog-content>
  <h1 style="text-align: center">{{ data.name | uppercase }}</h1>

  @if (data.name == 'area') {
    <form [formGroup]="areaForm"
      (ngSubmit)="areaForm.valid ? save(areaForm.value) : errorMessage()">
      <!-- Responsable new preventive -->
      <combos [configuration]="combosConfigResponsible" [required]="true" [filter]="true"
        (changeOption)="ValueResponsable($event)">
      </combos>
      <mat-form-field>
        <mat-label>Nombre</mat-label>
        <input autocomplete="off" type="text" formControlName="name" matInput placeholder="Nombre" required />
        <mat-error>Campo requerido</mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Código</mat-label>
        <input autocomplete="off" type="text" formControlName="code" matInput placeholder="Código" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>Descripción</mat-label>
        <input autocomplete="off" type="text" formControlName="description" matInput placeholder="Descripción" />
      </mat-form-field>
      <button color="warn" class="button-save mat-elevation-z5" [disabled]="areaForm.invalid" mat-raised-button
        type="submit">
        Guardar
      </button>
    </form>
  }

  @if (data.name == 'item') {
    <form [formGroup]="itemForm"
      (ngSubmit)="itemForm.valid ? save(itemForm.value) : errorMessage()">
      <mat-form-field>
        <mat-label>Código</mat-label>
        <input autocomplete="off" type="text" formControlName="code" matInput placeholder="Código" required />
      </mat-form-field>
      <mat-form-field>
        <mat-label>Nombre</mat-label>
        <input autocomplete="off" type="text" formControlName="itemName" matInput placeholder="Nombre" required />
        <mat-error>Campo requerido</mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Costo Item</mat-label>
        <input autocomplete="off" type="text" appThousandSeparator formControlName="costItem" matInput placeholder="Costo Item" required />
        <mat-error>Campo requerido</mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Unidad</mat-label>
        <input autocomplete="off" type="text" formControlName="unitMeasurement" matInput placeholder="Unidad" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>Descripción</mat-label>
        <input autocomplete="off" type="text" formControlName="description" matInput placeholder="Descripción" />
      </mat-form-field>
      <button color="warn" class="button-save mat-elevation-z5" [disabled]="itemForm.invalid" mat-raised-button
        type="submit">
        Guardar
      </button>
    </form>
  }

  @if (data.name == 'cargo') {
    <form [formGroup]="jobTitleForm"
      (ngSubmit)="jobTitleForm.valid ? save(jobTitleForm.value) : errorMessage()">
      <mat-form-field>
        <mat-label>Cargo</mat-label>
        <input autocomplete="off" type="text" formControlName="name" matInput placeholder="Cargo" required />
        <mat-error>Campo requerido</mat-error>
      </mat-form-field>
      <button color="warn" class="button-save mat-elevation-z5" [disabled]="jobTitleForm.invalid" mat-raised-button
        type="submit">
        Guardar
      </button>
    </form>
  }

  @if (data.name == 'tipo de equipo') {
<form [formGroup]="equipmentTypeForm" (ngSubmit)="
    equipmentTypeForm.valid ? save(equipmentTypeForm.value) : errorMessage()
  ">
      <mat-form-field>
        <mat-label>Tipo de equipo</mat-label>
        <input autocomplete="off" type="text" formControlName="name" matInput placeholder="Tipo de equipo" required />
        <mat-error>Campo requerido</mat-error>
      </mat-form-field>
      <button color="warn" class="button-save mat-elevation-z5" [disabled]="equipmentTypeForm.invalid" mat-raised-button
        type="submit">
        Guardar
      </button>
    </form>
  }

  @if (data.name == 'pais') {
    <form [formGroup]="countryForm"
      (ngSubmit)="countryForm.valid ? save(countryForm.value) : errorMessage()">
      <mat-form-field>
        <mat-label>Pais</mat-label>
        <input autocomplete="off" type="text" formControlName="country" matInput placeholder="Pais" required />
        <mat-error>Campo requerido</mat-error>
      </mat-form-field>
      <button color="warn" class="button-save mat-elevation-z5" [disabled]="countryForm.invalid" mat-raised-button
        type="submit">
        Guardar
      </button>
    </form>
  }

  @if (data.name == 'departamento') {
    <form [formGroup]="regionForm"
      (ngSubmit)="regionForm.valid ? save(regionForm.value) : errorMessage()">
      <mat-form-field>
        <mat-label>Pais</mat-label>
        <mat-select formControlName="countryId" required>
          @for (pais of comboCountry; track pais) {
            <mat-option value="{{ pais.id }}">
              {{ pais.country }}
            </mat-option>
          }
        </mat-select>
        <mat-error>Campo requerido</mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-label>departamento</mat-label>
        <input autocomplete="off" type="text" formControlName="region" matInput placeholder="departamento" required />
        <mat-error>Campo requerido</mat-error>
      </mat-form-field>
      <button color="warn" class="button-save mat-elevation-z5" [disabled]="regionForm.invalid" mat-raised-button
        type="submit">
        Guardar
      </button>
    </form>
  }

  @if (data.name == 'ciudad') {
    <form [formGroup]="cityForm"
      (ngSubmit)="cityForm.valid ? save(cityForm.value) : errorMessage()">
      <mat-form-field>
        <mat-label>departamento</mat-label>
        <mat-select formControlName="regionId" required>
          @for (departamento of comboRegions; track departamento) {
            <mat-option value="{{ departamento.id }}">
              {{ departamento.region }}
            </mat-option>
          }
        </mat-select>
        <mat-error>Campo requerido</mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-label>ciudad</mat-label>
        <input autocomplete="off" type="text" formControlName="city" matInput placeholder="ciudad" required />
        <mat-error>Campo requerido</mat-error>
      </mat-form-field>
      <button color="warn" class="button-save mat-elevation-z5" [disabled]="cityForm.invalid" mat-raised-button
        type="submit">
        Guardar
      </button>
    </form>
  }

  @if (data.name == 'eps') {
    <form [formGroup]="epsForm"
      (ngSubmit)="epsForm.valid ? save(epsForm.value) : errorMessage()">
      <mat-form-field>
        <mat-label>EPS</mat-label>
        <input autocomplete="off" type="text" formControlName="name" matInput placeholder="EPS" required />
        <mat-error>Campo requerido</mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Contacto</mat-label>
        <input autocomplete="off" type="text" formControlName="contactNumber" matInput placeholder="Contacto" required />
        <mat-error>Campo requerido</mat-error>
      </mat-form-field>
      <button color="warn" class="button-save mat-elevation-z5" [disabled]="epsForm.invalid" mat-raised-button
        type="submit">
        Guardar
      </button>
    </form>
  }

  @if (data.name == 'arl') {
    <form [formGroup]="arlForm"
      (ngSubmit)="arlForm.valid ? save(arlForm.value) : errorMessage()">
      <mat-form-field>
        <mat-label>ARL</mat-label>
        <input autocomplete="off" type="text" formControlName="name" matInput placeholder="ARL" required />
        <mat-error>Campo requerido</mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Contacto</mat-label>
        <input autocomplete="off" type="text" formControlName="contact" matInput placeholder="Contacto" required />
        <mat-error>Campo requerido</mat-error>
      </mat-form-field>
      <button color="warn" class="button-save mat-elevation-z5" [disabled]="arlForm.invalid" mat-raised-button
        type="submit">
        Guardar
      </button>
    </form>
  }

  @if (data.name == 'punto de control') {
<form [formGroup]="controlPointerForm" (ngSubmit)="
    controlPointerForm.valid ? save(controlPointerForm.value) : errorMessage()
  ">
      <mat-form-field>
        <mat-label>Nombre</mat-label>
        <input autocomplete="off" type="text" formControlName="name" matInput placeholder="Nombre" required />
        <mat-error>Campo requerido</mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Comentario</mat-label>
        <input autocomplete="off" type="text" formControlName="description" matInput placeholder="Comentario" />
      </mat-form-field>
      @if (!data.body.complete) {
        <div class="containerPhotos">
          <file-input [params]="fileInput" (fileSave)="fileSave($event)"></file-input>
        </div>
      }
      @if (imageSrc && data.body.complete) {
        <div class="containerPhotos">
          <img class="mat-elevation-z8" src="{{imageSrc}}" [ngStyle]="sizePicture">
        </div>
      }
      <button color="warn" class="button-save mat-elevation-z5" [disabled]="controlPointerForm.invalid" mat-raised-button
        type="submit">
        {{saveButtonNameCheckpoint}}
      </button>
    </form>
  }

  @if (data.name == 'comentario') {
    <form [formGroup]="commentForm"
      (ngSubmit)="commentForm.valid ? save(commentForm.value) : errorMessage()">
      <combos [configuration]="combosConfigCommentsTypes" [required]="true" [filter]="true"
        [control]="commentForm.get('commentTypeId')" (changeOptionDataComplete)="onChangeCommentType($event)"
        (returnDataCombo)="commentTypeData($event)">
      </combos>
      <mat-form-field>
        <mat-label>Comentario</mat-label>
        <textarea autocomplete="off" formControlName="comment" matInput #descripcion rows="3" maxlength="10000"
          placeholder="Comentario" class="min-rows-2" cdkTextareaAutosize cdkAutosizeMinRows="1"
        cdkAutosizeMaxRows="15"></textarea>
        <mat-hint>{{ descripcion.value.length }}/10000</mat-hint>
      </mat-form-field>
      @if (commentType && commentType.requiredFile) {
        <file-input class="w-100 mt-3" [params]="fileInputPdfOrImg"
        (fileSave)="fileSave($event)"></file-input>
      }
      <button color="warn" class="button-save mat-elevation-z5" [disabled]="commentForm?.invalid" mat-raised-button
        type="submit">
        Guardar
      </button>
    </form>
  }

</mat-dialog-content>